import { Translatable } from '@app/types/translatable.type';

const InterviewQuestionDisplayOptions: { [key: string]: Translatable } = {
    'Multiple Choice': 'applicant-tracker.questionTypes.multipleChoice',
    'Opinion Scale': 'applicant-tracker.questionTypes.opinionScale',
    'Open Question': 'applicant-tracker.questionTypes.openQuestion',
    'Yes / No': 'applicant-tracker.questionTypes.yesNoWithSpacing',
};

const InterviewQuestionTypeModeDisplayOptions: { [key: string]: Translatable } = {
    Numerical: 'applicant-tracker.numerical',
    Stars: 'applicant-tracker.stars',
    'Single-select': 'applicant-tracker.singleSelect',
    'Multiple-select': 'applicant-tracker.multipleSelect',
};

export { InterviewQuestionDisplayOptions, InterviewQuestionTypeModeDisplayOptions };
